/**
 * Module Client #07 — Bons signés
 */
const moduleClientBons = {
  id: 'client-bons-signes',
  population: 'client',
  order: 7,
  category: 'Documents',
  title: 'Bons signés',
  subtitle: 'Consulter et exploiter vos BC, BD et certificats',
  icon: 'ClipboardList',
  duration: '10 min',
  level: 'Débutant',
  slides: [
    { type: 'cover', eyebrow: 'Module 07 — Client', title: 'Bons signés', subtitle: 'Vos preuves opérationnelles à portée de clic', icon: 'ClipboardList', duration: '10 min', audience: 'Tous', level: 'Débutant' },
    { type: 'intro', title: 'Objectifs', intro: 'Vos bons signés (BC/BD) sont vos preuves juridiques de chargement et livraison. Apprenez à les exploiter.', objectives: [
      'Distinguer BC (chargement) et BD (déchargement)',
      'Filtrer par opération, date, plaque, statut signature',
      'Télécharger un PDF signé en 2 clics',
      'Vérifier la conformité OHADA (2 photos min, signatures, plaque)',
      'Comprendre la valeur juridique de la signature numérique',
    ]},
    { type: 'concept', eyebrow: 'Conformité', icon: 'Shield', title: 'Qu\'est-ce qu\'un bon signé valide ?',
      bullets: [
        '✍️ 2 signatures : expéditeur/destinataire + chauffeur',
        '📸 Minimum 2 photos OHADA (état avant + après)',
        '🚛 Plaque véhicule lisible et saisie',
        '🆔 NCC de l\'entreprise visible',
        '🕐 Horodatage GPS de chaque signature',
        '🔐 Hash SHA-256 d\'intégrité (anti-modification)',
      ],
      note: 'Un bon signé est juridiquement équivalent à un papier signé manuellement en présence d\'un huissier.',
    },
    { type: 'steps', title: 'Télécharger un BD signé', steps: [
      { title: 'Menu "Mes bons"', detail: 'Sidebar gauche.' },
      { title: 'Filtre "Type = BD"', detail: 'Liste réduite aux bons de déchargement.' },
      { title: 'Trouver l\'opération concernée', detail: 'Recherche par n° BAO-OP ou par client.' },
      { title: 'Bouton "Télécharger"', detail: 'PDF officiel signé numériquement.' },
    ]},
    { type: 'comparison', title: 'BC vs BD', do: [
      'BC : émis au chargement, signé par expéditeur + chauffeur',
      'BD : émis à l\'arrivée, signé par destinataire + chauffeur',
      'Les deux sont obligatoires pour la facturation',
      'Les deux sont conservés 10 ans (OHADA)',
    ], dont: [
      'Pas de BD = pas de facture validée',
      'Pas de BC = pas de couverture assurance',
      'Pas de modification possible après signature',
      'Pas d\'effacement du PDF (intégrité protégée)',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Vous avez besoin du BD pour une opération mais il n\'apparaît pas. Pourquoi ?',
      options: [
        'Le système est en panne',
        'L\'opération n\'est probablement pas encore livrée OU le destinataire n\'a pas encore signé',
        'Le BD a été supprimé',
        'Vous n\'avez pas les permissions',
      ],
      answerIndex: 1,
      explanation: 'Le BD est généré uniquement après signature du destinataire. Vérifier le statut de l\'opération : si "Livrée", contactez votre opérateur. Si "En route", c\'est normal.',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      'BC = chargement | BD = déchargement.',
      'Les 2 sont nécessaires pour facturation.',
      'PDF signé = opposable juridiquement.',
      'Conservation 10 ans obligatoire.',
    ]},
    { type: 'cta', title: 'Module 07 terminé !', actions: [
      { label: 'Mes bons signés', href: '/mes-bons' },
      { label: 'Catalogue', href: '/docs/client/training' },
    ]},
  ],
};
export default moduleClientBons;
